import { useEffect, useState } from 'react'
import { Form, Button, Alert } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { getActiveLoginCampaign, DEFAULT_LOGIN_CAMPAIGN } from './loginCampaigns'
import './Login.css'

/**
 * Fallback local si la API no responde (catálogo estático + /public/login-banners).
 * En operación normal la imagen viene de MEDIA vía /api/auth/login-campaigns/activa/.
 */
const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [panelSrc, setPanelSrc] = useState(null)
  const [campaign, setCampaign] = useState(() => getActiveLoginCampaign(new Date()))
  const { login } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false
    const fallback = getActiveLoginCampaign(new Date())

    fetch('/api/auth/login-campaigns/activa/')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('API campaign'))))
      .then((data) => {
        if (cancelled || !data) return
        setCampaign({
          id: data.codigo || fallback.id,
          title: data.titulo || fallback.title,
          subtitle: data.subtitulo || fallback.subtitle,
          image: data.imagen_url || fallback.image,
          accent: data.accent_color || fallback.accent,
        })
      })
      .catch(() => {
        if (!cancelled) setCampaign(fallback)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const imageSrc = panelSrc || campaign.image || DEFAULT_LOGIN_CAMPAIGN.image

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const result = await login(username, password)

    if (result.success) {
      navigate('/dashboard')
    } else {
      setError(result.error || 'Error al iniciar sesión')
    }

    setLoading(false)
  }

  return (
    <div
      className="login-page"
      style={{ '--login-accent': campaign.accent }}
      data-campaign={campaign.id}
    >
      <aside className="login-panel" aria-hidden={false}>
        <img
          className="login-panel__image"
          src={imageSrc}
          alt=""
          onError={() => {
            if (imageSrc !== DEFAULT_LOGIN_CAMPAIGN.image) {
              setPanelSrc(DEFAULT_LOGIN_CAMPAIGN.image)
            }
          }}
        />
        <div className="login-panel__veil" />
        <div className="login-panel__copy">
          <p className="login-panel__brand">Arithmos</p>
          <h1 className="login-panel__title">{campaign.title}</h1>
          <p className="login-panel__subtitle">{campaign.subtitle}</p>
        </div>
      </aside>

      <main className="login-form-wrap">
        <div className="login-form-card">
          <div className="login-form-header">
            <img
              src="/logo.png"
              alt="Arithmos"
              className="login-form-logo"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
            <h2>Iniciar sesión</h2>
            <p>Sistema contable y financiero</p>
          </div>

          {error && (
            <Alert variant="danger" dismissible onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="loginUsername">
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="loginPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </Form.Group>
            <Button type="submit" className="w-100" disabled={loading}>
              {loading ? 'Entrando…' : 'Entrar'}
            </Button>
            <p className="small text-center mt-3 mb-0">
              <Link to="/recuperar">¿Olvidaste tu contraseña?</Link>
            </p>
          </Form>
        </div>
      </main>
    </div>
  )
}

export default Login
